import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import formReducer from "./Slice";

const persistConfig = {
  key: "root",
  storage,
  whitelist: [
    "userData",
    "emailData",
    "eventId",
    "portfolioId",
    "newsId",
    "maincategoryId",
    "jobId",
    "createJobData",
    "teamData",
    "chatId",
    "userChatData",
    "applicants",
    "emailVerified",
    "routeData",
    "access_token",
  ],
};

const persistedReducer = persistReducer(persistConfig, formReducer);

const store = configureStore({
  reducer: {
    app: persistedReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
      },
    }),
});

const persistor = persistStore(store);

export { store, persistor };
